import React from 'react'

const PLAN_LABELS = {
  BASIC: 'Basic',
  STANDARD: 'Standard',
  PRO: 'Pro',
  ENTERPRISE: 'Enterprise',
}

export function isActiveOrgPaysContract(contract) {
  if (!contract || contract.orgId == null) return false
  const billingMode = String(contract.billingMode || contract.billingModel || '').toUpperCase()
  return contract.currentlyEffective === true && billingMode === 'ORG_PAYS'
}

export function normalizeActiveOrgContracts(contracts) {
  const byOrgId = new Map()
  const list = Array.isArray(contracts) ? contracts : []
  for (const contract of list) {
    if (!isActiveOrgPaysContract(contract)) continue
    const key = String(contract.orgId)
    if (!byOrgId.has(key)) byOrgId.set(key, contract)
  }
  return Array.from(byOrgId.values()).sort((a, b) => {
    const left = String(a?.orgName || '')
    const right = String(b?.orgName || '')
    return left.localeCompare(right, 'ko')
  })
}

function optionLabel(contract) {
  const orgName = contract?.orgName || '조직'
  const planLabel = PLAN_LABELS[String(contract?.appliedPlanCode || '').toUpperCase()] || ''
  return planLabel ? `${orgName} · ${planLabel}` : orgName
}

export default function OperatorOrgContractSelector({
  id = 'operator-org-contract',
  contracts,
  value,
  onChange,
  loading = false,
  disabled = false,
  className = '',
}) {
  const options = normalizeActiveOrgContracts(contracts)
  const selectDisabled = disabled || loading || options.length === 0

  return (
    <label className={`flex items-center gap-2 text-sm font-semibold text-slate-700 ${className}`} htmlFor={id}>
      조회 조직
      <select
        id={id}
        value={value || ''}
        onChange={(event) => onChange?.(event.target.value)}
        disabled={selectDisabled}
        className="min-h-[2.5rem] min-w-[14rem] rounded border border-slate-300 bg-white px-3 text-sm font-medium text-slate-800 focus:border-brand-sky focus:outline-none focus:ring-2 focus:ring-brand-sky/20 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500"
      >
        {loading && <option value="">조직계약 불러오는 중</option>}
        {!loading && options.length === 0 && <option value="">활성 조직계약 없음</option>}
        {!loading && options.map((contract) => (
          <option key={contract.orgId} value={String(contract.orgId)}>
            {optionLabel(contract)}
          </option>
        ))}
      </select>
    </label>
  )
}